import { useQuery } from '@tanstack/react-query';

import type { ConfigDeployStatusMap } from '@/api/deploy';
import { getConfigDeployStatuses } from '@/api/deploy';
import { buildConfigDeployStatusMap } from '@/components/deploy/config-deploy-status-helpers';
import { queryKeys } from '@/modules/query/query-keys';

/**
 * Fetches environment-scoped deployment statuses for config file deployments.
 * Returns a map of environmentId → { lastSuccess }.
 */
export function useConfigDeployStatus(projectKey: string) {
  return useQuery<ConfigDeployStatusMap>({
    queryKey: queryKeys.deployments.configStatuses(projectKey),
    queryFn: async () => {
      const deployments = await getConfigDeployStatuses(projectKey);
      return buildConfigDeployStatusMap(deployments);
    },
    enabled: !!projectKey,
    retry: 1,
    staleTime: 0,
  });
}
